import React from "react";
import "./TextColorPicker.scss";
import "../../../../components/ModalContent/ModalComponents.scss";
import { textColorOptions } from "../../../../utils/colors";

function TextColorPicker({ onSelectColor }) {
  return (
    <div className="text-color-picker-content">
      <div className="text-color-grid">
        {textColorOptions.map((color) => (
          <button
            key={color}
            className="text-color-option"
            style={{ backgroundColor: color }}
            onClick={() => onSelectColor(color)}
            aria-label={`Select color ${color}`}
          />
        ))}
      </div>
    </div>
  );
}

export default TextColorPicker;
